// ====================================================== //
// Startpage.js
// ====================================================== //
import React from "react";
import { Link } from "react-router-dom";
import "./Startpage.css";
import Header from "./components/Header";
import CompanyBanner from "./components/CompanyBanner";
import RecommendationBanner from "./components/RecommendationBanner";
import NewsBanner from "./components/NewsBanner";
import Footer from "./components/Footer";
import videoBg from "./assets/videos/qodes_video.mp4";

const Startpage = () => {
  const handleVideoLoad = (e) => {
    e.target.playbackRate = 0.7; // Adjust speed here
  };

  return (
    <div className="startpage">
      {/* ---------------- Header ---------------- */}
      <Header />

      {/* ---------------- Hero ------------------ */}
      <section className="section top-picture"> {/* Top Picture Section */}
        {/* Overlay div to darken the background */}
        <video
          autoPlay
          muted
          loop
          playsInline
          speed={0.5}
          className="background-video"
          onLoadedData={handleVideoLoad}
        >
          <source src={videoBg} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="hero-overlay" />
        <div className="page-container"> {/* Replace the existing overlay div */}
          <div className="overlay"> {/* Content */}
            <p className="hero-title">Shaping the future of Embedded Development</p>
            <p className="hero-subtitle">Ready to take the next step in your career?</p>
            <div className="buttons-start">
              <Link to="/contact" className="btn primary">Contact us</Link>
              <Link to="/about" className="btn secondary">Read more</Link>
            </div>
          </div>
        </div>
      </section>

      {/* -------------- Company Banner ---------- */}
      <CompanyBanner />

      {/* -------------- Placeholder sections ---- */}
      {/* -------------- Recommendation Banner --- */}
      <RecommendationBanner />
      <NewsBanner />
      <Footer />
    </div>
  );
};

export default Startpage;
